import "../../css/app.css";

const FILE_KB = 1024;
const FILE_MB = 1024 * 1024;
const FILE_GB = 1024 * 1024 * 1024;
const borderDecimalNumber = 9;


function FileListElement(props) {

    let fileSize = props.size;

    const getFirstDecimalPart = (num) => {
        let getDecimalVal = num.toString().indexOf(".");
        let decimalPart = num.toString().substring(getDecimalVal + 1);
        let firstNum = decimalPart.charAt(0);
        return parseInt(firstNum);
    }

    function ShowSize() {

        if (fileSize < FILE_KB) {
            let newFile = Math.round(fileSize);
            return (
                <div>
                    ファイルサイズ：{newFile}B
                </div>
            )
        }

        if (fileSize >= FILE_KB && fileSize < FILE_MB) {
            let newFile = (fileSize / 1024);
            if (getFirstDecimalPart(newFile) >= borderDecimalNumber) {
                newFile = Math.floor(newFile * 10) / 10;
                return (
                    <div>
                        ファイルサイズ：{newFile}KB
                    </div>
                )
            } else {
                newFile = Math.round(newFile * 10) / 10;
                return (
                    <div>
                        ファイルサイズ：{newFile}KB
                    </div>
                )
            }
        }

        if (fileSize >= FILE_MB && fileSize < FILE_GB) {
            let newFile = (fileSize / 1024 / 1024);
            if (getFirstDecimalPart(newFile) >= borderDecimalNumber) {
                newFile = Math.floor(newFile * 10) / 10;
                return (
                    <div>
                        ファイルサイズ：{newFile}MB
                    </div>
                )
            } else {
                newFile = Math.round(newFile * 10) / 10;
                return (
                    <div>
                        ファイルサイズ：{newFile}MB
                    </div>
                )
            }
        }

        if (fileSize >= FILE_GB) {
            let newFile = (fileSize / 1024 / 1024 / 1024);
            if (getFirstDecimalPart(newFile) >= borderDecimalNumber) {
                newFile = Math.floor(newFile * 10) / 10;
                return (
                    <div>
                        ファイルサイズ：{newFile}GB
                    </div>
                )
            } else {
                newFile = Math.round(newFile * 10) / 10;
                return (
                    <div>
                        ファイルサイズ：{newFile}GB
                    </div>
                )
            }
        }
    }

    return (
        <li key={props.size}>
            <div>
                <div>
                    ファイル名：{props.name}
                </div>
                <ShowSize />
                {props.isRemoveButton === true ?
                    <div className="btn">
                        <div className="comp-btn-clear">
                            <button type="button" onClick={() => props.onRemoveClick()}>クリア</button>
                        </div>
                    </div> : <br />}
            </div>
        </li>
    );
};
export default FileListElement;
